import { render, staticRenderFns } from "./SubtitlePage.vue?vue&type=template&id=d6f567e6&name=subtitle-page&"
import script from "./SubtitlePage.vue?vue&type=script&lang=js&"
export * from "./SubtitlePage.vue?vue&type=script&lang=js&"
import style0 from "./SubtitlePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports